import { useForm } from 'react-hook-form';
import {
  APPLY_COEFFICIENT,
  COEFFICIENT, STAKEHOLDER, TOPIC,
  VALUE_CHAIN_SECTION,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';

import type { TMAInsightsDashboardSchema } from 'utils/validators/MASurveyValidators';

const useSurveyAnswerForm = () => {
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { isDirty },
  } = useForm<TMAInsightsDashboardSchema>({
    mode: 'onChange',
    defaultValues: {
      [TOPIC]: undefined,
      [COEFFICIENT]: [],
      [STAKEHOLDER]: [],
      [APPLY_COEFFICIENT]: false,
      [VALUE_CHAIN_SECTION]: DEFAULT_OPTION,
    },
  });

  return {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    isDirty,
  };
};

export default useSurveyAnswerForm;
